import React from 'react';
import './PoseControls.css';

export function PoseControls({
  sourceMode,
  isStreaming,
  hasVideoUrl,
  isPlayingVideo,
  isPausedCamera,
  autoClipEnabled,
  onStartCamera,
  onStopCamera,
  onTogglePauseCamera,
  onTogglePlayVideo,
  onToggleAutoClip,
  onSnapshot,
  isLoadingModel,
}) {
  if (sourceMode === 'file') {
    return (
      <div className="pose-controls">
        <button
          type="button"
          className={`pose-btn ${isPlayingVideo ? 'pose-btn--pause' : 'pose-btn--primary'}`}
          onClick={onTogglePlayVideo}
          disabled={!hasVideoUrl || isLoadingModel}
          title={isPlayingVideo ? '동영상 일시 정지' : '동영상 재생 시작 및 자세 분석'}
        >
          <span>{isPlayingVideo ? '일시 정지' : '재생 시작'}</span>
        </button>

        <button
          type="button"
          className={`pose-btn ${autoClipEnabled ? 'pose-btn--autoclip-active' : 'pose-btn--autoclip'}`}
          onClick={onToggleAutoClip}
          disabled={!hasVideoUrl || isLoadingModel}
          title={
            autoClipEnabled
              ? 'AI 자동 컷팅 활성화됨 (사격 취소 시 자동 삭제)'
              : 'AI가 당김~발사 후 준비 복귀까지 1발씩 자동 분할 저장 (사격 취소 시 자동 삭제)'
          }
        >
          <span>{autoClipEnabled ? 'AI 자동 컷팅 ON' : 'AI 자동 컷팅'}</span>
        </button>
        <button
          type="button"
          className="pose-btn pose-btn--secondary"
          onClick={onSnapshot}
          disabled={!hasVideoUrl}
          title="현재 프레임 캡처 이미지 저장"
        >
          <span>현재 프레임 캡처</span>
        </button>
      </div>
    );
  }

  return (
    <div className="pose-controls">
      {!isStreaming ? (
        <button
          type="button"
          className="pose-btn pose-btn--primary"
          onClick={onStartCamera}
          disabled={isLoadingModel}
        >
          <span>카메라 시작</span>
        </button>
      ) : (
        <>
          <button
            type="button"
            className={`pose-btn ${isPausedCamera ? 'pose-btn--primary' : 'pose-btn--pause'}`}
            onClick={onTogglePauseCamera}
            title={isPausedCamera ? '실시간 분석 및 화면 재생 시작' : '현재 화면 일시 정지'}
          >
            <span>{isPausedCamera ? '재생 시작' : '일시 정지'}</span>
          </button>

          <button
            type="button"
            className={`pose-btn ${autoClipEnabled ? 'pose-btn--autoclip-active' : 'pose-btn--autoclip'}`}
            onClick={onToggleAutoClip}
            title={
              autoClipEnabled
                ? 'AI 자동 컷팅 켜짐 (사격 취소 시 자동 삭제)'
                : 'AI가 시위 당김~발사 후 준비 복귀까지 1발씩 자동 녹화 및 저장 (취소 시 자동 삭제)'
            }
          >
            <span>{autoClipEnabled ? 'AI 자동 컷팅 ON' : 'AI 자동 컷팅'}</span>
          </button>

          <button
            type="button"
            className="pose-btn pose-btn--secondary"
            onClick={onSnapshot}
            title="현재 화면 캡처 이미지 저장"
          >
            <span>자세 캡처 저장</span>
          </button>

          <button
            type="button"
            className="pose-btn pose-btn--stop"
            onClick={onStopCamera}
            title="카메라 분석 완전히 끄기"
          >
            <span>카메라 끄기</span>
          </button>
        </>
      )}
    </div>
  );
}
